<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ViewerControlsHelp from '@/components/bop/ViewerControlsHelp.vue'

defineProps<{
  fullscreen: boolean
  showControlsHelp?: boolean
}>()

const emit = defineEmits<{
  'reset-camera': []
  'toggle-fullscreen': []
}>()

const { t } = useI18n()
</script>

<template>
  <div class="viewer-toolbar">
    <v-btn
      icon
      size="small"
      variant="tonal"
      color="grey-darken-2"
      :title="t('component.bopModelViewer.resetCamera')"
      @click="emit('reset-camera')"
    >
      <v-icon>center_focus_strong</v-icon>
    </v-btn>
    <v-btn
      icon
      size="small"
      variant="tonal"
      color="grey-darken-2"
      :title="
        fullscreen
          ? t('component.bopModelViewer.exitFullscreen')
          : t('component.bopModelViewer.fullscreen')
      "
      @click="emit('toggle-fullscreen')"
    >
      <v-icon>{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
    </v-btn>
    <viewer-controls-help v-if="showControlsHelp" />
  </div>
</template>

<style scoped>
.viewer-toolbar {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
</style>
